import React from 'react';
import { useTranslation } from 'react-i18next';
import { appNamedRoutes } from 'routes';
import PageSubNav from 'components/nav/PageSubNav';

const AdministrationSubNav = () => {
  const { t } = useTranslation();
  const ADMINISTRATION_PAGES = [
    { path: appNamedRoutes.administrationStaff, label: t('administration.subNav.staff') },
    { path: appNamedRoutes.administrationOrganization, label: t('administration.subNav.organization') },
    { path: appNamedRoutes.administrationFamilies, label: t('administration.subNav.families') },
  ];
  return (
    <PageSubNav items={ADMINISTRATION_PAGES} />
  );
};

export default AdministrationSubNav;
